<script>
  import { onMount } from "svelte";
  export let currDate = 0;
  export let show_clock = false;
  export let show_date = false;

  let clock = undefined;
  let dateText = undefined;
  const newDate = async () => {

    let d = currDate == 0 ? new Date() : new Date(currDate)

    clock = new Intl.DateTimeFormat("pt", {
      hour: "numeric",
      minute: "numeric",
    }).format(d);

    dateText = new Intl.DateTimeFormat("pt", { dateStyle: 'long'})
      .format(d).toString().toLowerCase().split("de ").join("");
  };

  onMount(() => {
    newDate();
    const interval = setInterval(newDate, 5000); // every 5 seconds

    return () => {
      clearInterval(interval);
    };
  });
</script>

<span>
  <p>{show_clock ? clock : ''}</p>
  <p>{show_date ? dateText : ''}</p>
</span>
